import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 15px 15px 0;
  user-select: none;
  margin: 0 auto;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 100%;
    padding: 0;
  }
`;

export const Title = styled.h2`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  margin-bottom: 25px;
  font-size: 21px;
  line-height: 24px;
  color: ${COLORS.BLACK_BOLD};
  font-weight: 500;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 26px;
    line-height: 29px;
  }
`;

export const PriceConceptWraper = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const Information = styled.div`
  display: block;
  font-family: ${FONTS.ROBOTO};
  font-size: 15px;
  line-height: 16px;
  color: #444;
  margin: 15px 0 26px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 19px;
    margin: 26px 0;
  }
`;

export const ButtonActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
`;

const buttonStyle = css`
  font-weight: 600;
  font-family: ${FONTS.OPEN_SANS};
`;

export const ButtonPrevWrapper = styled(Button)`
  ${buttonStyle};
  font-size: 12px;

  span {
    text-align: left;
  }

  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  ${buttonStyle}
  font-size: 14px;

  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }
`;

export const Closure = styled.span`
  display: block;
  font-family: ${FONTS.ROBOTO_BOLD};
  margin-bottom: 4px;
`;

export const ClosureInfo = styled.p`
  margin-bottom: 2px;
`;

export const Footer = styled.div`
  width: 100%;
  padding: 15px;
  background-color: white;
  margin-top: auto;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 15px 40px 40px;
  }
`;

export const HeaderWrapper = styled.div`
  box-sizing: border-box;
  padding: 10px 21px 11px 21px;
  width: 100%;
  display: flex;
  min-height: 56px;
  flex-direction: row;
  align-items: center;
  background: ${COLORS.WHITE_DARK};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  position: sticky;
  z-index: 3000;
  top: 0;
  margin-top: -16px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 80px;
    margin-top: -18px;
    padding: 18px 21px 19px 21px;
  }
`;

export const TitleAsideModal = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  line-height: 19px;
  margin-left: 21px;
  font-weight: bold;
  color: #000000;

  span {
    display: block;
    color: ${COLORS.GRAY_TEXT};
    font-weight: normal;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
    line-height: 25px;
  }
`;

export const IconWraper = styled.span`
  cursor: pointer;
`;
